import cx from "classnames";

import { toDollars } from "common/utils/formatting";
import { isValueSet } from "common/utils";

import styles from "../../styles/CrossedPrice.module.less";

type CrossedPriceProps = {
  price?: number;
  crossed?: number;
  classNames?: {
    container?: string;
    price?: string;
    crossed?: string;
  };
};

const CrossedPrice = (props: CrossedPriceProps) => {
  const { price, crossed, classNames } = props;
  const showCrossed = !!crossed && (!price || crossed > price);

  return (
    <div className={cx(styles.container, classNames?.container)}>
      {showCrossed && (
        <span className={cx(styles.crossed, classNames?.crossed)}>{toDollars(crossed)}</span>
      )}
      {isValueSet(price) && (
        <span className={cx(styles.price, classNames?.price)}>{toDollars(price)}</span>
      )}
    </div>
  );
};

export default CrossedPrice;
